import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import FixedScrollSectionTemplate from "../../components/fixed-scroll-section";
import AgentEditForm from "./components/agent-edit-form/agent-edit-form";
import AgentDeleteForm from "./components/agent-delete-form/agent-delete-form";
import PanelLoading from "../../../../../components/panel/panel.loading";
import AgentsAdminLayout from "../../template/admin.layout";
import { useGetAgentById } from "../../../../../services/microservice/admin/agents/use-agents-admin";

const AgentEditPage = () => {
  const { id } = useParams();
  const {
    data: user,
    isLoading,
    refetch,
  } = useGetAgentById(
    { id },
    {
      enable: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, []);
  return (
    <AgentsAdminLayout>
      <div className="mt-32 h-full w-full pb-32">
        <FixedScrollSectionTemplate classname="h-full">
          <div className="my-6 flex flex-grow flex-col items-center justify-center">
            <div className="w-full md:w-3/4">
              <PanelLoading
                title={`Editar agente ${user?.data?.user?.name}`}
                isLoading={isLoading}
              >
                <AgentEditForm user={user?.data?.user} />
              </PanelLoading>
            </div>
            <div className="mt-10 w-full md:w-3/4">
              <PanelLoading
                title={`${user?.data?.user?.isActive ? "Inactivar" : "Activar"} agente ${user?.data?.user?.name}`}
                isLoading={isLoading}
                classname="h-48"
              >
                <AgentDeleteForm user={user?.data?.user} />
              </PanelLoading>
            </div>
          </div>
        </FixedScrollSectionTemplate>
      </div>
    </AgentsAdminLayout>
  );
};

export default AgentEditPage;
